import { Space, Tree, Row, Col, Form, Input, Button, Card, Spin } from "antd";
import { SearchOutlined, ReloadOutlined,DownloadOutlined } from "@ant-design/icons";
import service from "../../../@services";
import { useEffect, useState } from "react";
import CategoryPageTable from "./components/CategoryPageTable";
import AuthComponent from "../../../components/AuthComponent";
import * as Utils from '../../../@utils'
import "./index.less";
export default function Category(props) {
  const [form] = Form.useForm();
  const [treeLoading, setTreeLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [CategoryData, setCategoryData] = useState([]);
  const [tableData, setTableData] = useState({});
  useEffect(() => {
    getCategoryTree()
  }, []);
  const getCategoryTree = async () => {
    setTreeLoading(true)
    const cates = await service.common.getCategoryTree()
    setTreeLoading(false)
    setCategoryData(cates)
  }
  const onSearch = ({pageIndex=1, pageSize=10} = {}) => {
    const pagination = {pageIndex: pageIndex, pageSize: pageSize}
    const params = Object.assign({},form.getFieldsValue(),pagination)
    fetchData(params)
  }
  const fetchData = async (params) => {
    setLoading(true)
    const data = await service.category.getCategoryPageList(params)
    setLoading(false)
    if(data){
      setTableData(data)
    }
  }
  const onReset = () => {
    form.resetFields();
  };
  const exportCategory = async () => {
    const params = Object.assign({},form.getFieldsValue())
    const file = await service.category.exportCategory(params)
    const filename = '商品分类报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  };
  const selectTree = (selectedKeys, e)=>{
    form.setFieldsValue({
      categoryCode: selectedKeys[0]
    })
    onSearch()
  }
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card>
        <Form
          form={form}
          layout="inline"
        >
          <Form.Item name="categoryCode" label="类别编码">
            <Input style={{ width: 200 }} placeholder="请输入" />
          </Form.Item>
          <Form.Item name="categoryName" label="类别名称">
            <Input style={{ width: 200 }} placeholder="请输入" />
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/category/page">
              <Button type="primary" ghost icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
            </AuthComponent>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/category/page">
              <Button type="primary" ghost icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </AuthComponent>
          </Form.Item>
        </Form>
      </Card>
      <Card>
        <Space style={{ display: "flex", padding: "15px 0", marginTop: "-24px" }}>
          <AuthComponent authKey="/category/export">
            <Button type="primary" icon={<DownloadOutlined />} onClick={exportCategory}>导出</Button>
          </AuthComponent>
        </Space>
        <Row>
          <Col flex="300px">
            {
              treeLoading
              ? <Spin/>
              : <Tree
                className="category-tree"
                blockNode
                fieldNames={{title:'categoryName',key:'categoryCode',children:'children'}}
                treeData={CategoryData}
                onSelect={selectTree}
              />
            }
          </Col>
          <Col flex="auto">
            <CategoryPageTable 
              dataSource={tableData}
              loading={loading}
              handleTableChange={onSearch} />
          </Col>
        </Row>
      </Card>
    </Space>
  );
}
